"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageWizardFooter = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const helpers_1 = require("../../helpers");
const StackView_1 = require("../../StackView");
const View_1 = require("../../View");
const helpers_2 = require("../PageWizardBody/helpers");
const WrapperContent = styled_components_1.default.div ``;
const Root = (0, styled_components_1.default)(StackView_1.StackView) `
    height: ${helpers_1.SPACING_XXXL};
    background-color: ${({ theme }) => theme.colorHighlightNotification};

    ${({ fullWidthContent, widthContent }) => {
    if (fullWidthContent || widthContent === '100%') {
        return (0, styled_components_1.css) `
                justify-content: center;
            `;
    }
    return (0, styled_components_1.css) `
            padding-left: ${helpers_2.config.paddingOrMarginLeft};
            padding-right: ${helpers_2.config.paddingOrMarginRight};

            ${WrapperContent} {
                width: ${widthContent};
            }
        `;
}}
`;
const PageWizardFooter = (_a) => {
    var { fullWidthContent, widthContent, children } = _a, rest = __rest(_a, ["fullWidthContent", "widthContent", "children"]);
    return (react_1.default.createElement(Root, Object.assign({}, rest, { testId: rest['data-selector-id'] || 'pagewizard-wizardfooter', root: true, align: StackView_1.STACK_ALIGN.center, fullWidthContent: fullWidthContent, widthContent: widthContent, spaceFill: fullWidthContent ? undefined : View_1.SPACE_FILL.all }),
        react_1.default.createElement(WrapperContent, null, children)));
};
exports.PageWizardFooter = PageWizardFooter;
exports.PageWizardFooter.displayName = 'PageWizardFooter';
//# sourceMappingURL=PageWizardFooter.js.map